module.exports = __webpack_public_path__ + "static/media/Trophy2.de445a4b.svg";